import { render, staticRenderFns } from "./profile-update.vue?vue&type=template&id=fb1792b6&scoped=true"
import script from "./profile-update.vue?vue&type=script&lang=js"
export * from "./profile-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb1792b6",
  null
  
)

export default component.exports